module.exports = __webpack_public_path__ + "f5b094967ca53de55dca8838d1a9a04f.MP3";